import { CustomCard } from "../CustomCard/CustomCard";
import React, { useContext } from "react";
import {
  formatCurrency,
  isInstitutionGrouped,
  renderStatusLabels,
  renderTravel,
} from "../../../utils/constants";
import { RenderCostsTable } from "./RenderCostsTable";
import { getTvaRatio } from "../../../utils/helpersFunction";
import { UserContext } from "../../../engine/context/User.context";
import { t } from "i18next";

export const RenderCosts = ({
  cost,
  title,
  loading,
  prestationVue,
  prestation,
}) => {
  if (cost === null) {
    return null;
  }

  const { configuration } = useContext(UserContext);

  const renderLinesCost = (costs, costParams, params) => {
    return (
      <>
        {costs?.map(entry => {
          return (
            <div className={"row-price"}>
              <p>{entry.title}</p>

              <div className={"row-price-sub"}>
                <span className={"row-price-left"}>
                  {entry.type === "travel"
                    ? renderTravel(entry, costParams, params?.billing)
                    : entry.description
                        .split("\n")
                        .map((line, index, array) => (
                          <React.Fragment key={index}>
                            {line}
                            {index === array.length - 1 ? null : <br />}
                          </React.Fragment>
                        ))}
                </span>

                <span className={"row-price-right"}>
                  {formatCurrency(entry.amount)}
                </span>
              </div>
            </div>
          );
        })}
        {costs === undefined
          ? `${t("RenderCosts.prestation")}: ${renderStatusLabels(
              prestation.status,
              prestation.subStatus,
            )}`
          : ""}
        <div className={"row-price-total"}>
          <div className={"row-price-sub"}>
            <span className={"row-price-left-total"}>
              {t("RenderCosts.totalNet")}
            </span>
            <span className={"row-price-right-total"}>
              {formatCurrency(costParams?.total)}
            </span>
          </div>
        </div>
        {costParams?.tvaAmount !== undefined && costParams?.tvaAmount !== 0 && (
          <div>
            <div className={"row-price-sub"}>
              <span className={"row-price-left"}>
                {t("RenderCosts.tvaLabel", {
                  tvaRatio: getTvaRatio(cost?.prestationsRef?.year) * 100,
                })}{" "}
              </span>
              <span className={"row-price-right"}>
                {formatCurrency(costParams?.tvaAmount)}
              </span>
            </div>
          </div>
        )}
        {costParams?.totalHorsTva !== undefined &&
          costParams?.totalHorsTva !== 0 && (
            <div>
              <div className={"row-price-sub"}>
                <span className={"row-price-left-total"}>
                  {t("RenderCosts.totalNoTva")}
                </span>
                <span className={"row-price-right-total"}>
                  {formatCurrency(costParams?.totalHorsTva)}
                </span>
              </div>
            </div>
          )}
        {costParams?.roundCorrection !== 0 &&
        costParams?.roundCorrection !== undefined ? (
          <div>
            <div className={"row-price-sub"}>
              <span className={"row-price-left"}>
                {t("RenderCosts.roundCorrection")}
              </span>
              <span className={"row-price-right"}>
                {formatCurrency(costParams?.roundCorrection)}
              </span>
            </div>
          </div>
        ) : null}
        {costParams?.isCancelInterprete !== undefined &&
          costParams?.isCancelInterprete === true && (
            <div>
              <div className={"row-price-sub"}>
                <span className={"row-price-left"}>
                  {t("RenderCosts.canceledInterpreter")}
                </span>
                <span className={"row-price-right"}></span>
              </div>
            </div>
          )}
        {costParams?.isCanceledClient !== undefined &&
          costParams?.isCanceledClient === true && (
            <div>
              <div className={"row-price-sub"}>
                <span className={"row-price-left"}>
                  {configuration?.bill?.cancelationType === "less24hours" && (
                    <>
                      {costParams.cancelSince >= 4 &&
                      costParams.cancelSince < 24
                        ? t("RenderCosts.canceledBetween24And4")
                        : ""}
                      {costParams.cancelSince < 4
                        ? t("RenderCosts.canceledLessThan4")
                        : ""}
                    </>
                  )}

                  {configuration?.bill?.cancelationType ===
                    "less4openingHours" && (
                    <>{t("RenderCosts.canceledLessThan4Opening")}</>
                  )}
                </span>
                <span className={"row-price-right"}></span>
              </div>
            </div>
          )}
        {costParams?.totalWithTva !== undefined &&
          costParams?.totalWithTva !== 0 && (
            <div className={"row-price-total"}>
              <div className={"row-price-sub"}>
                <span className={"row-price-left-total"}>
                  {t("RenderCosts.totalWithTva")}
                </span>
                <span className={"row-price-right-total"}>
                  {formatCurrency(costParams?.totalWithTva)}
                </span>
              </div>
            </div>
          )}
      </>
    );
  };

  if (isInstitutionGrouped(cost?.institution, prestation) === true) {
    let item;
    let presta;

    if (prestationVue) {
      item = cost.costsMultiple.find(p => p.prestationId === prestation._id);
      presta = cost?.prestations?.find(p => p?._id === prestation?._id);
    }

    return (
      <>
        {!prestationVue && (
          <CustomCard
            title={t("RenderCosts.totalCostsTitle")}
            loading={loading}
          >
            {renderLinesCost(cost?.costs, cost?.costParams, {
              description: false,
              billing: cost?.institution?.defaultAddress,
            })}
          </CustomCard>
        )}
        <br />

        {!prestationVue ? (
          <RenderCostsTable cost={cost} />
        ) : (
          <CustomCard
            title={
              <>
                {title}
                {prestationVue === false
                  ? `: ${t("RenderCosts.prestationNumber")} ${
                      prestation.reference
                    }`
                  : ""}
              </>
            }
            loading={loading}
            style={{ marginBottom: 20 }}
          >
            {renderLinesCost(item?.cost, item?.costParams, {
              billing: presta?.billing,
            })}
          </CustomCard>
        )}
      </>
    );
  } else {
    let billing;

    if (prestationVue) {
      billing = prestation.billing;
    } else {
      billing = cost.prestations.length > 0 && cost.prestations[0].billing;
    }
    return (
      <CustomCard title={title} loading={loading}>
        {renderLinesCost(cost?.costs, cost?.costParams, {
          billing: billing,
        })}
      </CustomCard>
    );
  }
};
